module.exports = __webpack_public_path__ + "img/barmen-coctail-1600x800.9368ceca.jpg";